<template>
<div class="ApplyRecord">
    <el-table :data="ApplyRecordList" style="width: 100%">
        <el-table-column label="岗位名称" align="center" width="156">
            <template slot-scope="scope">
                <p class="name_text" style="cursor: pointer; color: #409EFF;" @click="jobClick(scope.row)">{{scope.row.jobname}}</p>
            </template>
        </el-table-column>
        <el-table-column label="公司名称" align="center" width="160">
            <template slot-scope="scope">
                <p class="name_text">{{scope.row.companydisplayname}}</p>
            </template>
        </el-table-column>
        <el-table-column label="薪资待遇" align="center" prop="salarytext" width="148"></el-table-column>
        <el-table-column label="工作经验" align="center" prop="exptypename"></el-table-column>
        <el-table-column label="工作地点" align="center" prop="jobplace"></el-table-column>
        <el-table-column label="投递时间" align="center" prop="datetime" width="150"></el-table-column>
        <el-table-column label="状态" align="center">
            <template slot-scope="scope">
                <p v-if="scope.row.status === 1 || scope.row.status === 9 || scope.row.status === 20" class="green_text">已投递</p>
                <p v-if="scope.row.status === 10" class="yellow_text">投递成功</p>
                <p v-if="scope.row.status === 11" class="red_text">已谢绝</p>
            </template>
        </el-table-column>
    </el-table>
    <el-pagination background layout="prev, pager, next" :current-page.sync='params.page'  @current-change="handleCurrentChange" :total="totalCount"></el-pagination>
</div>
</template>

<script>
import {getResumeedLiveInfo} from 'api/talentApi'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'ApplyRecord',
    data() {
        return {
            totalCount: 0,
            params: {page: 1, pageSize: 10},
            ApplyRecordList: []
        }
    },
    mounted() {
        this.findResumeedLiveInfo(1)
    },
    methods: {
        jobClick(val) {
            this.$router.push({name: 'JobInfo', query: {jobid: val.jobinnerid}})
        },
        findResumeedLiveInfo(page) {
            var params = {
                page: page,
                pageSize: 10
            }
            getResumeedLiveInfo({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.ApplyRecordList = data.data.content
                    this.totalCount = data.data.pageinfo.rowCount
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        handleCurrentChange(val) {
            this.findResumeedLiveInfo(val)
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'user'
        ])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss">
.ApplyRecord {
    padding-top: 12px;
    padding-bottom: 30px;
    .el-table {
        thead {
            th {
                background: #E5E5E5;
            }
        }
        .name_text {
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            word-break: break-all;
        }
        .green_text {
            color: #0ABF53;
        }
        .yellow_text {
            color: #FF7F04;
        } 
        .red_text {
            color: #F56C6C;
        }
    }
}
</style>